import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import { GwProductList } from "../list/interface";
import GwProductRepository from "../../../repositories/gw-product-repository";
import { GwProduct } from "../../../models/gw-product";

export const useGetGwProduct = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<GwProductList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [gwProductData, setGwProductData] = useState<GwProduct | null>(null);
  const [isOnFetchingGwProductData, setIsOnFetchingGwProductData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await GwProductRepository.all(params)
      .then((response: AxiosResponse<ICollection<GwProductList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadGwProductData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingGwProductData(true);

      await GwProductRepository.show(id, params)
        .then((response: AxiosResponse<IResource<GwProduct>>) => {
          setGwProductData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingGwProductData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadGwProductData,
    isOnFetchingGwProductData,
    gwProductData,
  };
};
